// Size the URL bar to its content; only the editor reserves a lens definition line.
.urlBar {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.875rem 1.25rem;
  background: var(--color-code-background);
  border-bottom: 1px solid var(--color-code-border);

  &[data-lens-line] {
    min-height: 4.85rem;
  }
}

// A stack makes a long URL: it wraps instead of running out of sight.
.url,
.lensLine {
  display: block;
  font-family: var(--font-mono, ui-monospace, monospace);
  font-size: 0.8125rem;
  line-height: 1.6;
  overflow-wrap: anywhere;
  color: var(--color-code-foreground);
}

.lensLine {
  color: var(--color-code-comment);
}

.lensName {
  color: var(--color-code-function);
}

.selector {
  padding-block: 0.125rem;
  -webkit-box-decoration-break: clone;
  box-decoration-break: clone;
  border-radius: var(--radius-sm);
  background: var(--color-code-background-raised);
  color: var(--color-code-constant);
}

// The step being applied while the loop plays.
.step {
  -webkit-box-decoration-break: clone;
  box-decoration-break: clone;
  border-radius: var(--radius-sm);
  transition:
    background-color 200ms ease,
    color 200ms ease;

  &[data-active] {
    background: var(--color-primary);
    color: var(--color-primary-foreground);
  }
}

.signature {
  margin-inline-start: 0.25rem;
  color: var(--color-code-string);
}

// The link that opens the URL, after it.
.open {
  display: inline-flex;
  margin-inline-start: 0.5rem;
  vertical-align: middle;
  color: var(--color-code-function);

  &:hover {
    color: var(--color-code-foreground);
  }

  &:focus-visible {
    outline: 3px solid var(--color-focus-ring);
    outline-offset: 2px;
    border-radius: var(--radius-sm);
  }
}
